<template>
    <div class="pagination-wrapper row">
        <div class="col-sm-3">
            <p>نمایش <span>{{meta.from}}</span> تا <span>{{meta.to}}</span> از <span>{{meta.total}}</span> نتیجه</p>
        </div>
        <div class="col-sm-9">
            <div class="row justify-content-end">
                <div class="col col-auto">
                    <div class="d-flex">
                        <label class="text-nowrap align-self-center pe-2">تعداد در صفحه</label>
                        <select class="form-select" v-model="per_page">
                            <option value="20" v-bind:selected="per_page==20">20</option>
                            <option value="50" v-bind:selected="per_page==50">50</option>
                            <option value="100" v-bind:selected="per_page==100">100</option>
                            <option value="200" v-bind:selected="per_page==200">200</option>
                        </select>
                    </div>
                </div>
                <div class="col col-auto">
                    <ul class="pagination mb-0" v-if="meta.total > meta.per_page">
                        <li class="page-item first" :class="{disabled:meta.current_page==1}"><button class="page-link" @click="goToPage(0)">ابتدا</button></li>
                        <li class="page-item previous" :class="{disabled:disablePrev}"><button class="page-link" @click="prevPage()">قبلی</button></li>
                        <li class="page-item page-number" v-for="page in pages" :class="{active:(meta.current_page==page)}">
                            <button class="page-link" @click="goToPage(page)">{{page}}</button>
                        </li>
                        <li class="page-item next" :class="{disabled:disableNext}"><button class="page-link" @click="nextPage()">بعدی</button></li>
                        <li class="page-item last" :class="{disabled:meta.last_page==meta.current_page}"><button class="page-link" @click="goToPage(meta.last_page)">انتها</button></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props : {
            params : {type: Object, required: true},
            meta : {type: Object, required: true}
        },
        data(){
            return {
                disableNext : false,
                disablePrev : false,
            }
        },
        computed: {
            page: {
                get(){
                    if(this.params.hasOwnProperty('page')){
                        return this.params.page;
                    }
                    return 1;
                },
                set(value){
                    this.params.page = value;
                }
            },
            order_by: {
                get(){
                    if(this.params.hasOwnProperty('order_by')){
                        return this.params.order_by;
                    }
                    return 'created_at';
                },
                set(value){
                    this.params.order_by = value;
                }
            },
            order_dir: {
                get(){
                    if(this.params.hasOwnProperty('order_dir')){
                        return this.params.order_dir;
                    }
                    return 'desc';
                },
                set(value){
                    this.params.order_dir = value;
                }
            },
            per_page: {
                get(){
                    if(this.params.hasOwnProperty('per_page')){
                        return this.params.per_page;
                    } else {
                        return 20;
                    }
                },
                set(value){
                    this.params.per_page = value;
                }
            },
            //for watching the changes of per_page
            pages(){
                let pages_from = 0, pages_to = 0;
                if(this.page < 4){
                    pages_to = 6;
                }else if(this.page > this.meta.last_page - 3){
                    pages_to = this.meta.last_page;
                }else{
                    pages_to = this.page + 3;
                }
                pages_from = pages_to - 5;

                if(pages_to > this.meta.last_page){
                    pages_to = this.meta.last_page;
                }

                let pageNumbers = [];
                for (let i = pages_from; i <= pages_to; i++){
                    pageNumbers.push(i);
                }
                return pageNumbers;
            }
        },
        methods: {
            nextPage(){
                if(!this.disableNext)
                    this.page++;
            },
            prevPage(){
                if(!this.disablePrev)
                    this.page--;
            },
            goToPage(page){
                this.page = page;
            },
        },
        watch:{
            //Check When Changing Responses
            meta(){
                this.disableNext =  this.meta.current_page == this.meta.last_page;
                this.disablePrev =  this.meta.current_page == 1;
            },
            //Reset pagination on changing per_page
            per_page(){
                this.page = 1;
            }
        }
    }
</script>
